module.exports = __webpack_public_path__ + "img/6_10.21b9c1b0.png";